import React from 'react'
import { Link, graphql } from 'gatsby'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import '../../utils/fontawesome'
import SEO from '~/components/seo'
import Layout from '../../layouts'
import styled from 'styled-components'
import {
  Img
} from '~/utils/styles'
// import 'react-responsive-carousel/lib/styles/carousel.min.css'
import '~/components/carousel.css'
import ProductForm from '~/components/ProductForm'
import { Carousel } from 'react-responsive-carousel'

const ProductPage = ({ data }) => {
  const product = data.shopifyProduct
  const { markdownRemark: post, footerData, navbarData, bannerData } = data
  return (
    <>
      <Layout navbarData={navbarData} footerData={footerData} bannerData={bannerData}>
        <section className='section' style={{ minHeight: '100vh' }}>
        <SEO title={product.title} description={product.description} />
          <div className='hero'>
            <div className='hero-body'>

              <div className='columns is-multiline is-centered'>
                <div className='column is-12 is-offset-2'>
                  <Link to='/#products' className='button is-medium is-primary is-outlined' style={{ marginBottom: '2rem' }}><FontAwesomeIcon icon='angle-left' />&nbsp;Weitershoppen</Link>
                </div>
                <div className='column is-6'>
                  <div className='columns'>
                    <div className='column is-10 is-offset-2'>

                      <Carousel width='100%' showThumbs={false} showArrows={true} showStatus={false}  showIndicators={true}>
                        {product.images.map(image => (
                          <div key={image.id}>
                            <div style={{ maxWidth: '350px', margin: '0 auto' }}>
                              <Img
                                fluid={image.localFile.childImageSharp.fluid}
                                key={image.id}
                                alt={product.title}
                              />
                            </div>
                          </div>
                        ))}
                      </Carousel>
                    </div>
                  </div>
                </div>

                <div className='column is-6'>
                  <ProductTitle>{product.title}</ProductTitle>
                  <ProductDescription
                    dangerouslySetInnerHTML={{ __html: product.descriptionHtml }}
                  />
                  <ProductForm product={product} />

                </div>
              </div>
            </div>
          </div>
        </section>
      </Layout>
    </>
  )
}

export const query = graphql`
  query($handle: String!) {
    shopifyProduct(handle: { eq: $handle }) {
      id
      title
      handle
      productType
      description
      descriptionHtml
      shopifyId
      options {
        id
        name
        values
      }
      variants {
        id
        title
        price
        availableForSale
        shopifyId
        selectedOptions {
          name
          value
        }
      }
      priceRange {
        minVariantPrice {
          amount
          currencyCode
        }
        maxVariantPrice {
          amount
          currencyCode
        }
      }
      images {
        originalSrc
        id
        localFile {
          childImageSharp {
            fluid(maxWidth: 350) {
              ...GatsbyImageSharpFluid_withWebp_tracedSVG
            }
          }
        }
      }
    }
    ...LayoutFragment
  }
`

export default ProductPage


const ProductTitle = styled.h1`
  font-size: 2.25rem;
  margin-bottom: 15px;
  word-wrap: break-word;
  font-family: "Montserrat";
  text-transform: uppercase;
  margin: 0 0 0.5rem;
  line-height: 1.4;
`

const ProductDescription = styled.div`
  margin-top: 40px;
  font-family: "Roboto",sans-serif;
  font-weight: 300;
`

const PriceTag = styled.span`
  font-weight: 900;
  font-size: 1rem;
  text-align: center;
  margin-top: 15px;
  // :before {
  //   content: '- '
  // }
`
